import { isEqual } from 'lodash';

import * as apiNamesListModule from '@/data/apiEndpointNames';

const apiNamesList: Record<string, object> = apiNamesListModule;

export function getApiName(apiDetail: Record<string, string>) {
	const apiNameKey = Object.keys(apiNamesList).find((key) =>
		isEqual(apiNamesList[key], apiDetail),
	);
	return apiNameKey ?? apiDetail.endPoint;
}
